import { render, staticRenderFns } from "./ProgramRules.vue?vue&type=template&id=d005d0ba"
import script from "./ProgramRules.vue?vue&type=script&lang=js"
export * from "./ProgramRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports